import { formatStatValue, type StatFormat } from '@/utils/formatStat';

interface StatItemProps {
    label: string;
    value: number | null | undefined;
    format: StatFormat;
    /**
     * Percentage of the network total for this stat, shown as a small green
     * sub-line under the value when the bar is scoped to an Area of Interest
     * or DMA. Null/undefined hides the sub-line (network view, missing total).
     */
    percentOfTotal?: number | null;
}

export function StatItem({ label, value, format, percentOfTotal }: StatItemProps) {
    const formatted = formatStatValue(value, format);

    // Figma: value Poppins ExtraBold size/2xl leading/8 on the left; label (muted,
    // Poppins Medium size/xs leading/4) with the green percent line stacked beneath
    // it on the right. Poppins is the app sans, so no explicit font-family needed.
    return (
        <div className="flex shrink-0 items-center gap-2 px-4">
            <span className="text-origin-blue text-2xl leading-8 font-extrabold tracking-normal whitespace-nowrap">
                {formatted}
            </span>
            <div className="flex flex-col items-start">
                <span className="text-muted-foreground max-w-28 text-xs leading-4 font-medium tracking-normal text-balance break-words md:max-w-none md:break-normal md:whitespace-nowrap">
                    {label}
                </span>
                {percentOfTotal != null && (
                    <span className="text-origin-green text-xs leading-4 font-medium tracking-normal whitespace-nowrap">
                        {percentOfTotal}% of total
                    </span>
                )}
            </div>
        </div>
    );
}

export function StatItemSkeleton() {
    return (
        <div className="flex shrink-0 items-center gap-2 px-4">
            <div className="bg-muted h-8 w-14 animate-pulse rounded" />
            <div className="bg-muted h-4 w-20 animate-pulse rounded" />
        </div>
    );
}
